import { Icons } from './Icons';

export { Icons };
